import React from 'react';
import './detailDeepBoxEmployee.css'

const DetailDeepBoxEmployee = ({ title, data }) => {

  
  return (
    <div className='detail-deep-box-employee__container'>
      <h3>{title}</h3>
      <div className="detail-deep-box-employee__description-container">
        <p>{data}</p>
      </div>
    </div>
  );
};

export default DetailDeepBoxEmployee;